import { Jane, OrderStatus, OrderStatusEnum } from 'types/graphql';
import { LocationOptionType } from 'components/LocationFilterInput/LocationFilterInput.types';
import { useIsSentToAgencyJane } from 'hooks/useAgencyHooks/useAgencyHooks';

type IUseIsJaneCommunityMismatch = {
  acceptedBySharedTeamMember: Nullable<boolean>;
  status: OrderStatus;
  orderCommunityOrgId?: Nullable<number>;
  currentlySelectedLocation: LocationOptionType;
  isMultiLocationCallOutFeatureEnabled: boolean;
  isMultiLocationSchedulingFeatureEnabled: boolean;
  isMultiLocationTieringFeatureEnabled: boolean;
  mainJane: Jane | null;
  sentToAgencies: boolean;
};
export const useIsJaneCommunityMismatch = ({
  acceptedBySharedTeamMember,
  status,
  mainJane = null,
  sentToAgencies,
  orderCommunityOrgId,
  currentlySelectedLocation,
  isMultiLocationCallOutFeatureEnabled = false,
  isMultiLocationSchedulingFeatureEnabled = false,
  isMultiLocationTieringFeatureEnabled = false,
}: IUseIsJaneCommunityMismatch): boolean => {
  const isSentToAgencyJane = useIsSentToAgencyJane({
    mainJane,
    sentToAgencies,
    orderCommunityOrgId,
  });
  if (isMultiLocationCallOutFeatureEnabled || isMultiLocationTieringFeatureEnabled)
    return (
      !!mainJane &&
      !isSentToAgencyJane &&
      `${mainJane?.primaryCommunity?.id}` !== currentlySelectedLocation?.value?.toString()
    );
  else
    return (
      isMultiLocationSchedulingFeatureEnabled &&
      !!mainJane &&
      !isSentToAgencyJane &&
      (!acceptedBySharedTeamMember || status.value === OrderStatusEnum.assigned) &&
      `${mainJane?.primaryCommunity?.id}` !== currentlySelectedLocation?.value?.toString()
    );
};
